import { connect } from 'react-redux';
import GDPRDeleteButton from '../../../common/buttons/gdprDeleteButton';
import { getIsReadOnlyAdminUser } from '../../../auth/selectors';

export default connect((state, ownProps) => ({
  disabled: ownProps.disabled || getIsReadOnlyAdminUser(state),
}))(GDPRDeleteButton);
